import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import FeedbackCollector from '@atlaskit/feedback-collector';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useSpaceRoleMode } from '@confluence/space-utils/entry-points/useSpaceRoleMode.ts';

const i18n = defineMessages({
	feedbackTitle: {
		id: 'space-roles.feedback-collector.title',
		defaultMessage: 'Give feedback',
		description:
			'Title for a feedback collector that asks for feedback on a new permissions experience',
	},
	feedbackTitleDetails: {
		id: 'space-roles.feedback-collector.title-details',
		defaultMessage:
			'How satisfied or dissatisfied are you overall with your experience using roles to manage access in Confluence?',
		description:
			'Title details for a feedback collector that asks for feedback on a new permissions experience',
	},
});

const FEEDBACK_CONTEXT_ID = 'customfield_10047';
const ENTRYPOINT_ID = 'ba8149f4-b7d4-4f55-9e72-683a444d3b27';

export const SpaceRolesFeedbackCollector = ({
	isOpen,
	onClose,
	onSubmit,
	source,
}: {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: () => void;
	source: string;
}): React.JSX.Element | null => {
	const { formatMessage, locale } = useIntl();
	const { displayName, userId, cloudId, edition, environment } = useSessionData();
	const { spaceRoleMode } = useSpaceRoleMode();

	const getFeedbackMetadata = (): string => {
		const feedbackMetadata = {
			userId,
			cloudId,
			edition,
			environment,
			source,
			spaceRoleMode,
		};
		return JSON.stringify(feedbackMetadata, null, 2);
	};

	if (!isOpen) {
		return null;
	}

	return (
		<FeedbackCollector
			onClose={onClose}
			onSubmit={onSubmit}
			entrypointId={ENTRYPOINT_ID}
			locale={locale}
			name={displayName ?? ''}
			atlassianAccountId={userId ?? undefined}
			showTypeField={false}
			feedbackTitle={formatMessage(i18n.feedbackTitle)}
			feedbackTitleDetails={formatMessage(i18n.feedbackTitleDetails)}
			additionalFields={[
				{
					id: FEEDBACK_CONTEXT_ID,
					value: getFeedbackMetadata(),
				},
			]}
		/>
	);
};
